import { render, staticRenderFns } from "./portfolioStrats.vue?vue&type=template&id=f39d016e&scoped=true&"
import script from "./portfolioStrats.vue?vue&type=script&lang=js&"
export * from "./portfolioStrats.vue?vue&type=script&lang=js&"
import style0 from "./portfolioStrats.vue?vue&type=style&index=0&id=f39d016e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39d016e",
  null
  
)

export default component.exports